import { SafeAreaInsets } from './types';

export const FALLBACK_SAFE_AREA_INSETS: SafeAreaInsets = {};
